import { ISources, SourcesResponseType } from "@/entity/sources/sources.types"


export class SourceCategoriesForm {
    public name: string | null
    public color: string | null

    setFormData(data: SourcesResponseType) {
        this.name = data.name
        this.color = data.color
    }

    constructor() {
        this.name = ''
        this.color = ''
    }
}